﻿const scriptRegistry = new Map();

export function loadScriptOnce(src, options = {}) {
    const {
        async = true,
        defer = true,
        attrs = {}
    } = options;

    if (!src) {
        return Promise.reject(new Error("Script src is required."));
    }

    if (scriptRegistry.has(src)) {
        return scriptRegistry.get(src);
    }

    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
        const resolved = Promise.resolve(existing);
        scriptRegistry.set(src, resolved);
        return resolved;
    }

    const promise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = async;
        script.defer = defer;

        Object.entries(attrs).forEach(([key, value]) => {
            script.setAttribute(key, value);
        });

        script.onload = () => resolve(script);
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

        document.head.appendChild(script);
    });

    scriptRegistry.set(src, promise);
    return promise;
}